import { AllergyIntolerance } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const allergiesAdapter = createEntityAdapter({
  selectId: (allergy: AllergyIntolerance) => allergy.id!,
});

const reducers = {
  loadAllergies: allergiesAdapter.setAll,
  createManyAllergies: allergiesAdapter.addMany,
  createAllergy: allergiesAdapter.addOne,
  removeAllergy: allergiesAdapter.removeOne,
  updateAllergy: allergiesAdapter.updateOne,
};

export const allergiesSlice = createSlice({
  name: "ClientAllergies",
  initialState: allergiesAdapter.getInitialState(),
  reducers,
});

export const { loadAllergies, createAllergy, createManyAllergies, removeAllergy, updateAllergy } =
  allergiesSlice.actions;

const selectAllergiesEntities = (state: RootState) => state.clientAllergies.entities;

export const selectAllergiesList = createSelector(
  [selectAllergiesEntities],
  (clientAllergiesEntities): AllergyIntolerance[] => Object.values(clientAllergiesEntities),
);

export default allergiesSlice.reducer;
